export default {
  setAccountInterests(state, data) {
    state.interests = data;
  },
  addAccountInterest(state, data) {
    state.interests.push(data);
  },
};
